import React, { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const initialLoggedIn = !!localStorage.getItem("token");
  const initialUser = JSON.parse(localStorage.getItem("user")) || {
    firstname: "",
    lastname: "",
    username: "",
  };

  const [loggedIn, setLoggedIn] = useState(initialLoggedIn);
  const [isLoggedIn, setIsLoggedIn] = useState(initialUser)
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    setLoggedIn(initialLoggedIn);
  }, [initialLoggedIn]);

  return (
    <AuthContext.Provider value={{ loggedIn, isLoggedIn, isAuthorized, setLoggedIn, setIsLoggedIn, setIsAuthorized }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
